var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292007 4.70706C0.1052 4.51817 0.000427246 4.26322 0.000427246 3.99756C0.000427246 3.7319 0.1052 3.47695 0.292007 3.28806L3.23101 0.323059C3.44901 0.108059 3.73101 0.00105953 4.01001 0.00105953C4.28901 0.00105953 4.56601 0.108059 4.77901 0.323059L7.70901 3.27806C7.89557 3.46708 8.00018 3.72197 8.00018 3.98756C8.00018 4.25314 7.89557 4.50804 7.70901 4.69706C7.61718 4.79024 7.50773 4.86424 7.38705 4.91475C7.26636 4.96526 7.13684 4.99127 7.00601 4.99127C6.87518 4.99127 6.74565 4.96526 6.62497 4.91475C6.50428 4.86424 6.39484 4.79024 6.30301 4.69706L4.00501 2.38006L1.69801 4.70706C1.60597 4.79988 1.49646 4.87356 1.3758 4.92383C1.25514 4.97411 1.12572 5 0.995008 5C0.864292 5 0.73487 4.97411 0.614211 4.92383C0.493552 4.87356 0.384044 4.79988 0.292007 4.70706Z",
    fill: "#13334C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.8345fef38d6062241e052d4e5b4043d6.svg";
export { ForwardRef as ReactComponent };